import { render, staticRenderFns } from "./Jellyfish.vue?vue&type=template&id=c2faf4f0&"
import script from "./Jellyfish.vue?vue&type=script&lang=js&"
export * from "./Jellyfish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports